export const TICKET_TRANSACTION_TYPE_ID = "TRANSACTION_TYPE.BUS_TICKET";

export interface ILoyaltyTier {
  id: string;
  name: string;
  pointsFrom: number;
  pointsTo: number;
  rate: number;
  isActive: boolean;
  color: string;
  locales: ILocaleTranslation[];
}

export interface ITransactionRate {
  id: string;
  organization: { name: string; id: number };
  currency: { name: string; id: string };
  transactionType: { name: string; id: string };
  rate: number;
}

export interface ITiersConfig {
  tiers: ILoyaltyTier[];
  transactionRates: ITransactionRate[];
}

export interface ILocaleTranslation {
  name: string;
  culture: ICultureInfo;
}

export interface ICultureInfo {
  name: string;
  id: string;
}

